import { render, staticRenderFns } from "./ProdutoTab.vue?vue&type=template&id=14475aa6&scoped=true"
import script from "./ProdutoTab.vue?vue&type=script&lang=js"
export * from "./ProdutoTab.vue?vue&type=script&lang=js"
import style0 from "./ProdutoTab.vue?vue&type=style&index=0&id=14475aa6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14475aa6",
  null
  
)

export default component.exports